import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AccountTy } from "../../../config/types";
import { AppThunk } from "../..";

const initialState: AccountTy = {

    isNewUser: false,
  is_verified: false,
  is_active: false
};

export const authAccount = createSlice({
  name: "authVerify",
  initialState,

  reducers: {
    updateAccount: (_state, action: PayloadAction<AccountTy>) => {
      return action.payload;
    },
  },
});


export const { updateAccount } = authAccount.actions;
export const toggleNewUser=(data:Partial<AccountTy>):AppThunk=> async (dispatch)=>{
  dispatch(updateAccount({isNewUser: true,is_active:data.is_active??false,is_verified:data.is_verified??false}));

}
export default authAccount.reducer;
